const moment = require("moment");

// Mantem o contrato legado do investira.sdk sem puxar o bundle minificado
// que tenta resolver locales dinamicamente no diretório /min.
require("moment/locale/pt-br");

module.exports = moment;
